import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import ArrowLeftIcon from "@dcl/icons/esm/ui/arrow-left";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";

var CarouselNavigation = function CarouselNavigation(props) {
  var getClassName = getClassNameFactory(CarouselNavigation.displayName);
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: getClassName({
      states: classNames({
        navigationHide: props.numberPages === 1
      })
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "button"
    }),
    disabled: !props.previousVisible,
    onClick: props.previousSlideFunc
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, null))), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "pagination"
    })
  }, props.paginationArray.map(function (index) {
    return /*#__PURE__*/React.createElement("li", {
      className: getClassName({
        descendantName: "paginationDot",
        states: classNames({
          currentDot: index === props.pageIndex - 1
        })
      }),
      key: index
    });
  })), /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "button"
    }),
    disabled: !props.nextVisible,
    onClick: props.nextSlideFunc
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null))));
};

CarouselNavigation.displayName = "CarouselNavigation";
CarouselNavigation.propTypes = {
  previousVisible: PropTypes.bool,
  previousSlideFunc: PropTypes.func,
  nextSlideFunc: PropTypes.func,
  nextVisible: PropTypes.bool,
  pageIndex: PropTypes.number,
  paginationArray: PropTypes.array,
  numberPages: PropTypes.number
};
export default CarouselNavigation;